import { Component, Input, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-merge-quote-edit',
  templateUrl: './merge-quote-edit.component.html',
  styleUrls: ['./merge-quote-edit.component.scss'],
})
export class MergeQuoteEditComponent implements OnInit {
  warningMsg: any
  mergeQuoteMsg: any

  constructor(private launchDialogService: LaunchDialogService) {}
  ngOnInit(): void {
    this.launchDialogService.data$.subscribe((data) => {
      this.warningMsg = data.warningMsg
      if(data.mergeQuoteMsg){
        this.mergeQuoteMsg = data.mergeQuoteMsg
      }
    })
  }

  closeModal(message): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.MERGE_QUOTE_EDIT,
      reason: message,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
